import React from 'react';
import Yaktrek from '../assets/yaktrek.jpg';

const YakTrekSection = () => {
  return (
    <section className="w-full max-w-[1920px] mx-auto relative bg-white">
      <div className="relative w-full">
        <img
          src={Yaktrek}
          alt="Yak Trek in Snow"
          className="w-full h-auto object-cover block"
        />
        <div className="absolute bottom-0 left-0 w-full flex flex-col items-center justify-end pb-16 px-4 text-center bg-gradient-to-t from-white via-white/80 to-transparent pt-20">
          
          {/* Title */}
          <h2 className="font-serif text-2xl md:text-3xl uppercase tracking-widest text-stone-800 mb-6 border-b border-dotted border-stone-400 pb-1 inline-block">
            BodiosYak
          </h2>

          {/* Body Paragraph */}
          <p className="font-serif text-xs md:text-sm text-stone-600 max-w-4xl leading-relaxed">
            BODIOS, a distinguished family-owned Mongolian brand with 30 years of
            heritage, is now proudly led by its second generation. With privileged
            access to 60% of Mongolia's yak down, we meticulously oversee each step
            of the process to create an extraordinary softness—an embodiment of
            luxury at its finest. Seamlessly merging traditional craftsmanship with
            contemporary design, BODIOS offers timeless pieces that resonate with
            refined taste and uncompromising quality....
          </p>
        </div>
      </div>
    </section>
  );
};

export default YakTrekSection;